<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">{{"COMMON.ADD" | translate}} {{"COMMON.RATINGS"|translate}}</h5>
        <div class="edit-icons" (click)="onCancel()">
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-content d-flex flex-column justify-content-center m-h">
        <h6 class="mt-4 r-t">How would you rate this employee?</h6>
        <form action="" [formGroup]="addForm" (ngSubmit)="onSubmit()">
            <div class="mt-3">
                <div class="rating d-flex justify-content-center">
                    <ngb-rating [(rate)]="currentRate" [max]="maxs" formControlName="rating">
                        <ng-template let-fill="fill" let-index="index">
                            <i class="bi-star{{fill === 100 ? '-fill' : ''}}" [class.filled]="fill === 100"
                                [class.low]="index < 2"></i>
                        </ng-template>
                    </ngb-rating>
                </div>
            </div>
            <div class="mt-3">
                <textarea name="" class="form-control" id="" cols="10" rows="4" formControlName="comment"
                    placeholder="Write additional comments here...."></textarea>
                <mat-error *ngIf="isControlHasError('msg','required')"> {{"This is required"|translate}}</mat-error>
            </div>
        </form>
    </div>
    <div class="row">
        <div class="col-md-6 m-auto">
            <button mat-raised-button color="primary" class="auth-form-btn mt-3 mt-lg-4" type="submit"
                (click)="onSubmit()">{{ "Save" | translate }}</button>
        </div>
    </div>
</div>
<app-loading-spinner></app-loading-spinner>